import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  deleteSavedListMutationOptions,
  removeCreatorsFromSavedListMutationOptions,
} from '@/entities/saved-creators-list';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { trackEvent } from '@/shared/track';

export function useDeleteSavedProfileListMutation() {
  const queryClient = useQueryClient();
  const { workspaceId } = useWorkspaceId();
  const options = deleteSavedListMutationOptions(queryClient, workspaceId);

  return useMutation({
    ...options,
    onSuccess: async (data, variables, onMutateResult, context) => {
      await options.onSuccess?.(data, variables, onMutateResult, context);
      trackEvent('Saved_list', 'delete_list');
    },
  });
}

export function useRemoveSavedProfilesFromListMutation() {
  const queryClient = useQueryClient();
  const { workspaceId } = useWorkspaceId();
  const options = removeCreatorsFromSavedListMutationOptions(queryClient, workspaceId);

  return useMutation({
    ...options,
    onSuccess: async (data, variables, onMutateResult, context) => {
      await options.onSuccess?.(data, variables, onMutateResult, context);
      trackEvent('Saved_list', 'remove_creators');
    },
  });
}
